import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { useI18n } from "../i18n";
import { shareSite } from "../share";
import LogoMark, { Wordmark } from "./LogoMark";

export default function Footer() {
    const { t } = useI18n();
    const [copied, setCopied] = useState(false);
    const share = async () => {
        const res = await shareSite(t.sub);
        if (res === "copied") {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };
    return (
        <footer className="relative border-t border-white/10 py-14" data-testid="footer">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
                    <div>
                        <a href="#" className="flex items-center gap-2.5" data-testid="footer-logo">
                            <LogoMark size={34} glitch />
                            <Wordmark className="text-2xl" />
                        </a>
                        <p className="mt-3 max-w-xs text-sm leading-relaxed text-zinc-500">{t.ft1}</p>
                    </div>
                    <div className="flex items-center gap-6 text-sm font-medium text-zinc-400 sm:gap-8">
                        <a href="#kalkulator" className="transition-colors hover:text-white" data-testid="footer-link-kalkulator">
                            {t.n1}
                        </a>
                        <a href="#cara-kerja" className="transition-colors hover:text-white" data-testid="footer-link-cara-kerja">
                            {t.n2}
                        </a>
                        <a href="#faq" className="transition-colors hover:text-white" data-testid="footer-link-faq">
                            {t.n3}
                        </a>
                        <button
                            onClick={share}
                            data-testid="footer-share"
                            aria-label={t.n5}
                            title={t.n5}
                            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-zinc-300 transition-colors duration-200 hover:border-white/40 hover:text-white"
                        >
                            {copied ? <Check size={16} className="text-emerald-400" /> : <Share2 size={16} />}
                        </button>
                    </div>
                </div>
                <div className="mt-12 flex flex-col gap-3 border-t border-white/5 pt-6 text-xs text-zinc-600 sm:flex-row sm:items-center sm:justify-between">
                    <p data-testid="footer-copyright" className="flex flex-wrap items-center gap-1.5">
                        {t.ft2} · Supported by
                        <img
                            src="/porsche.png"
                            alt="Porsche"
                            className="inline-block h-4 w-auto"
                            data-testid="footer-porsche"
                        />
                    </p>
                    <p className="max-w-md leading-relaxed" data-testid="footer-disclaimer">
                        {t.ft3}
                    </p>
                </div>
            </div>
        </footer>
    );
}
